import clsx from 'clsx';
import { useSpring, a } from 'react-spring';

import chain from '@/assets/chain.svg';

const sizes = {
  sm: 'h-2',
  md: 'h-4',
  lg: 'h-6',
  xl: 'h-8',
};

export type ChainDividerProps = {
  size?: keyof typeof sizes;
  className?: string;
  animate?: boolean;
};

export const ChainDivider = ({
  size = 'sm',
  className = '',
  animate = false,
}: ChainDividerProps) => {
  return (
    <div
      className={clsx(sizes[size], 'w-full', className, animate && 'animate-bgScroll')}
      style={{
        backgroundImage: `url(${chain})`,
        backgroundRepeat: 'repeat-x',
      }}
    />
  );
};

export const AnimatedChainDivider = ({
  scroll = false,
  delay = 400,
  divClassName = '',
  ...rest
}: {
  scroll?: boolean;
  delay?: number;
  divClassName?: string;
} & ChainDividerProps) => {
  const spring = useSpring({
    from: { width: '0%' },
    to: { width: '100%' },
    delay,
  });
  return (
    <a.div className={divClassName} style={spring}>
      <ChainDivider animate={scroll} {...rest} />
    </a.div>
  );
};
